// Team Members filtered list variant.
// Extends FilteringModule with team-member-specific selectors.
// Depends on filtering.js being loaded first.

document.addEventListener('DOMContentLoaded', function () {
    // On load-more pages, LoadMoreModule handles all filtering — skip FilteringModule.
    if (document.querySelector('.filtered-content-load-more')) return;

    FilteringModule({
        selectors: {
            ajaxUrlSource: '[data-variant="team-members"]',
        },
        renderError(container) {
            container.innerHTML = '<div class="rounded-lg bg-red-50 p-8 text-center"><p class="text-red-600">Error loading team members. Please try again.</p></div>';
        },
    }).init();
});
